import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../context/authContext';
import useHttp from './useHttp';

// Loads the booking-widget empty-availability diagnostic records (dev-only).
// Each record holds the exact start-times request the browser sent and the
// response it received, plus a client-side verdict classifying whether the
// "empty" state looks like a measurement error.
const useAvailabilityDiagnostics = () => {
  const { sendRequest, isLoading } = useHttp();
  const { getAuthHeaders } = useAuth();
  const [data, setData] = useState(null);

  const fetchDiagnostics = useCallback(
    async ({ widgetId, startDate, endDate, limit } = {}) => {
      try {
        const response = await sendRequest({
          url: '/api/v1/widgetAnalytics/availabilityDiagnostics',
          method: 'GET',
          headers: getAuthHeaders(),
          params: { widgetId, startDate, endDate, limit },
        });
        if (response) setData(response);
        return response;
      } catch (err) {
        toast.error('Fehler beim Laden der Verfügbarkeits-Diagnostik');
        throw err;
      }
    },
    [sendRequest, getAuthHeaders]
  );

  return { data, isLoading, fetchDiagnostics };
};

export default useAvailabilityDiagnostics;
